export default __webpack_public_path__ + "static/opengraph_wide-491ad92142cbe29275350d6a1c5ea142.png";